import React, { Component } from 'react'
import './index.css'

export default class Title extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeSlide: 1,
      transition: false
    }
  }

  didTransitionEnd(el) {
    const transitions = {
      'transition': 'transitionend',
      'OTransition': 'oTransitionEnd',
      'MozTransition': 'transitionend',
      'WebkitTransition': 'webkitTransitionEnd'
    }

    for (const t in transitions) {
      if (el.style[t] !== undefined) {
        return transitions[t]
      }
    }
  }

  updateImage() {
    const { activeSlide } = this.state

    this.setState({
      transition: true
    }, () => {
      const el = document.querySelector('.Hero .slider')
      el.addEventListener(this.didTransitionEnd(el), () => {
        this.setState({
          activeSlide: activeSlide === 4 ? 1 : activeSlide + 1
        }, () => {
          el.querySelector('img').addEventListener('load', () => {
            setTimeout(() => {
              this.setState({ transition: false })
            }, 400)
          })
        })
      })
    })
  }

  componentDidMount() {
    setInterval(() => this.updateImage(), 4000)
  }

  render() {
    const { activeSlide } = this.state
    const { data } = this.props

    return (
      <div className="Hero">
        <h1>{data.titel}</h1>
        <p>{data.subtitel}</p>
        <div
          className={`slider ${this.state.transition && 'transition'}`}
          style={{
            backgroundImage: `url(${require(`../../Assets/Images/Hero/${activeSlide}.jpg`)})`
          }}>
          <img
            src={require(`../../Assets/Images/Hero/${activeSlide}.jpg`)}
            alt="BIZON Prefab house"
            style={{ display: 'none' }} />
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/Hero/index.js